import {Footer as ThemeFooter} from '@constellation/core';
import {type VFC} from 'react';
import {styled} from 'styled-components';
import {LegalInformationElement} from '../LegalInformation/Loadable.js';
import FooterContent from './FooterContent/FooterContent.js';

const StyledFooter = styled.footer``;

type footerContent = {
  text: string;
  link: string;
};

type footerProps = {
  footerContent: footerContent[];
};

const Footer: VFC<footerProps> = ({footerContent}) => (
  <StyledFooter data-testid='cardnet-footer'>
    <LegalInformationElement />
    <ThemeFooter showBackToTop={true}>
      <FooterContent footerContent={footerContent} />
    </ThemeFooter>
  </StyledFooter>
);

export default Footer;
